import { render, staticRenderFns } from "./ru.vue?vue&type=template&id=12dc2eee&scoped=true&lang=html&"
import script from "./ru.vue?vue&type=script&lang=js&"
export * from "./ru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc2eee",
  null
  
)

export default component.exports